<header class="guild-dashboard-header">
  <div class="header-content">
    <div class="header-main">
      <ng-container *ngIf="guild; else loadingHeader">
        <div class="guild-info">
          <img *ngIf="guild.id && guild.icon; else defaultIcon" 
               class="guild-header-icon" 
               alt="guild-icon" 
               src="https://cdn.discordapp.com/icons/{{ guild.id }}/{{ guild.icon }}.png?size=64" />
          <div class="guild-title-group">
            <h1 class="guild-title">{{ guild?.name }}</h1>
            <div class="guild-header-actions">
              <button *ngIf="isOverlay"
                      type="button"
                      class="nav-menu-button"
                      [attr.aria-expanded]="mobileOpen"
                      aria-controls="guild-sidenav"
                      [attr.aria-label]="mobileOpen ? 'Close menu' : 'Open menu'"
                      (click)="toggleMobileNav()">
                <fa-icon [icon]="mobileOpen ? faIcon.times : faIcon.menubar"></fa-icon>
              </button>
              <button class="guild-selection-button" routerLink="/guilds">
                <fa-icon [icon]="faIcon.arrowLeft" class="button-icon"></fa-icon>
                <span>Guild Selection</span>
              </button>
              <mat-form-field *ngIf="isWebsiteBotOwner" class="view-as-select" appearance="fill">
                <mat-label>View as</mat-label>
                <mat-select [(ngModel)]="selectedViewAs" (selectionChange)="setViewAs($event.value)">
                  <mat-option *ngFor="let option of viewAsOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="guild && !guild.has_premium">
      <div class="header-ad-container">
        <div class="ad-description" *ngIf="showDescription" [innerHTML]="ads[ads_nr].description"
             (mouseenter)="enterDescription()" (mouseleave)="leaveDescription()"></div>
        <a href="{{ ads[ads_nr].url }}" target="_blank" rel="noopener" class="ad-link">
          <div class="ad-image-container">
            <img class="ad-image" alt="{{ ads[ads_nr].name }}" src="{{ ads[ads_nr].image }}"
                 (mouseenter)="enterImage()" (mouseleave)="leaveImage()"/>
          </div>
        </a>
      </div>
    </ng-container>
  </div>
</header>

<ng-container *ngIf="guild">
  <div *ngIf="isWebsiteBotOwner && guild.preview_read_only" class="preview-banner">
    Bot-owner preview is active. You are viewing this dashboard as
    <strong>{{ getViewAsLabel(guild.view_as) }}</strong>;
    all changes are blocked in this mode.
    <span *ngIf="!guild.bot_owner_access">
      Switch View as to <strong>Your permissions (edit)</strong> to make changes on servers you belong to.
    </span>
  </div>
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav id="guild-sidenav"
                 [mode]="isOverlay ? 'over' : 'side'"
                 [opened]="isOverlay ? mobileOpen : true"
                 [disableClose]="!isOverlay"
                 (openedChange)="onSidenavOpenedChange($event)">
      <button *ngIf="isOverlay" type="button" class="sidebar-close-btn" aria-label="Close menu" (click)="mobileOpen = false">
        <fa-icon [icon]="faIcon.times"></fa-icon>
      </button>
      <div class="sidebar-header" *ngIf="guild.channels.length > 0">
        <a routerLink="event/create" 
           routerLinkActive="router-link-active"
           [routerLinkActiveOptions]="{exact: false}"
           class="create-event-button">
          <fa-icon [icon]="faIcon.add" class="create-event-icon"></fa-icon>
          <span class="create-event-text">Create Event</span>
        </a>
      </div>
      <mat-accordion class="example-headers-align" multi>
        
        <!-- Flattened top-level navigation items -->
        <mat-nav-list>
          <a mat-list-item
             routerLink="premium" 
             routerLinkActive="router-link-active"
             [routerLinkActiveOptions]="{exact: true}"
             class="premium-nav-link">
            <span class="premium-badge">✨</span>
            <span class="premium-text"> Premium</span>
          </a>
          <a mat-list-item
             routerLink="overview"
             routerLinkActive="router-link-active"
             [routerLinkActiveOptions]="{exact: true}"
             [class.router-link-active]="isOverviewRoute()">Overview</a>
          <a mat-list-item 
             routerLink="server" 
             routerLinkActive="router-link-active"
             [routerLinkActiveOptions]="{exact: true}">Server Settings</a>
          <mat-expansion-panel [expanded]="channelSelected">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Channel Settings
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list>
              <a mat-list-item 
                *ngFor="let channel of guild?.channels"
                routerLink="channel/{{channel.id}}"
                routerLinkActive="router-link-active"
                [routerLinkActiveOptions]="{exact: false}">{{channel.name}}</a>
              <a mat-list-item
                [class.add-entry-button-disabled]="!guild.owner || (guild.channels.length >= guild.limits.max_event_channels && !guild.has_premium)"
                [class.add-entry-button-enabled]="guild.owner && (guild.channels.length < guild.limits.max_event_channels || guild.has_premium)"
                [appDisableLink]="!guild.owner || (guild.channels.length >= guild.limits.max_event_channels && !guild.has_premium)"
                [disabled]="!guild.owner || (guild.channels.length >= guild.limits.max_event_channels && !guild.has_premium)"
                routerLink="channel/new"
                routerLinkActive="router-link-active"
                [routerLinkActiveOptions]="{exact: true}"
                [matTooltip]="!guild.owner ? 'No permission to create a channel setup' : (guild.channels.length >= guild.limits.max_event_channels && !guild.has_premium) ? 'Maximum number of event channels exceeded' : ''"
                [matTooltipPosition]="'below'"
                [style.cursor]="!guild.owner ? 'not-allowed' : ''">
                <fa-icon [icon]="faIcon.add"></fa-icon> Add Channel
              </a>
            </mat-nav-list>
          </mat-expansion-panel>
          <a mat-list-item 
             routerLink="user" 
             routerLinkActive="router-link-active"
             [routerLinkActiveOptions]="{exact: true}">User Settings</a>
        </mat-nav-list>

        <!-- Repeating Events -->
        <mat-expansion-panel [expanded]="repeatingEventSelected">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Repeating Events
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item *ngFor="let repeating_event of guild?.repeating_events"
              [disabled]="!repeating_event.access"
              [style.cursor]="!repeating_event.access ? 'not-allowed' : ''"
              [matTooltip]="!repeating_event.access ? 'No permission to edit this entry' : ''"
              [appDisableLink]="!repeating_event.access"
              [routerLink]="'repeating-event/' + repeating_event.id"
              routerLinkActive="router-link-active"
              [routerLinkActiveOptions]="{exact: false}">
              {{repeating_event.name}}
            </a>
            <a mat-list-item
              [class.add-entry-button-disabled]="!guild.organizer || (guild.repeating_events.length >= guild.limits.max_repeating_events && !guild.has_premium)"
              [class.add-entry-button-enabled]="guild.organizer && (guild.repeating_events.length < guild.limits.max_repeating_events || guild.has_premium)"
              [appDisableLink]="!guild.organizer || (guild.repeating_events.length >= guild.limits.max_repeating_events && !guild.has_premium)"
              [disabled]="!guild.organizer || (guild.repeating_events.length >= guild.limits.max_repeating_events && !guild.has_premium)"
              routerLink="repeating-event/new"
              routerLinkActive="router-link-active"
              [routerLinkActiveOptions]="{exact: true}"
              [matTooltip]="guild.organizer && (guild.repeating_events.length >= guild.limits.max_repeating_events && !guild.has_premium) ? 'Maximum number of custom signup templates exceeded' : ''"
              [matTooltipPosition]="'below'"
              [style.cursor]="!guild.organizer ? 'not-allowed' : ''"
              [matTooltip]="!guild.organizer ? 'No permission to create a repeating event' : ''">
              <fa-icon [icon]="faIcon.add"></fa-icon> Add Entry
            </a>
          </mat-nav-list>
        </mat-expansion-panel>
        <!-- Signup Templates -->
        <mat-expansion-panel [expanded]="signupTemplateSelected">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Signup Templates
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item *ngFor="let signup_template of guild?.signup_templates"
              [disabled]="!guild.owner"
              [style.cursor]="!guild.owner ? 'not-allowed' : ''"
              [matTooltip]="!guild.owner ? 'No permission to edit this signup group' : ''"
              [appDisableLink]="!guild.owner"
              [routerLink]="'signup-template/' + signup_template.id"
              routerLinkActive="router-link-active"
              [routerLinkActiveOptions]="{exact: false}">
              {{signup_template.name}}
            </a>
            <a mat-list-item
              [class.add-entry-button-disabled]="!guild.owner || (guild.signup_templates.length >= guild.limits.max_custom_templates && !guild.has_premium)"
              [class.add-entry-button-enabled]="guild.owner && (guild.signup_templates.length < guild.limits.max_custom_templates || guild.has_premium)"
              [appDisableLink]="!guild.owner || (guild.signup_templates.length >= guild.limits.max_custom_templates && !guild.has_premium)"
              [disabled]="!guild.owner || (guild.signup_templates.length >= guild.limits.max_custom_templates && !guild.has_premium)"
              routerLink="signup-template/new"
              routerLinkActive="router-link-active"
              [routerLinkActiveOptions]="{exact: true}"
              [matTooltip]="guild.owner && (guild.signup_templates.length >= guild.limits.max_custom_templates && !guild.has_premium) ? 'Maximum number of custom signup templates exceeded' : ''"
              [matTooltipPosition]="'below'"
              [style.cursor]="!guild.owner ? 'not-allowed' : ''"
              [matTooltip]="!guild.owner ? 'No permission create a signup group' : ''">
              <fa-icon [icon]="faIcon.add"></fa-icon> Add Entry
            </a>
          </mat-nav-list>
        </mat-expansion-panel>
        <!-- Signup Groups -->
        <mat-expansion-panel [expanded]="signupGroupSelected">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Signup Groups
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item *ngFor="let signup_group of guild?.signup_groups"
              [disabled]="!guild.owner || !guild.has_premium"
              [appDisableLink]="!guild.owner || !guild.has_premium"
              [routerLink]="'signup-group/' + signup_group.id"
              routerLinkActive="router-link-active"
              [routerLinkActiveOptions]="{exact: false}">
              {{signup_group.name}}
            </a>
            <a mat-list-item
              [class.add-entry-button-disabled]="!guild.owner || !guild.has_premium"
              [class.add-entry-button-enabled]="guild.owner && guild.has_premium"
              [appDisableLink]="!guild.owner || !guild.has_premium"
              [disabled]="!guild.owner || !guild.has_premium"
              routerLink="signup-group/new"
              routerLinkActive="router-link-active"
              [routerLinkActiveOptions]="{exact: true}"
              [matTooltip]="guild.owner && !guild.has_premium ? 'Signup Groups require premium' : ''"
              [matTooltipPosition]="'below'">
              <fa-icon [icon]="faIcon.add"></fa-icon> Add Entry
            </a>
          </mat-nav-list>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="content mat-elevation-z8">
        <div *ngIf="!isPremiumRoute()" class="card-content">
          <router-outlet></router-outlet>
        </div>
        <div *ngIf="isPremiumRoute()">
          <router-outlet></router-outlet>
        </div>
      </div>
    </mat-sidenav-content>

  </mat-sidenav-container>
</ng-container>

<ng-template #defaultIcon>
  <img class="card-img-top" class="rounded-circle ms-2 d-none d-sm-inline" alt="guild-icon" src="https://cdn.discordapp.com/icons/{{ raidOrganizerGuild.id }}/{{ raidOrganizerGuild.icon }}.png?size=64">
</ng-template>

<ng-template #loadingHeader>
  <h1 class="bd-title mt-0">
    <div class="content_loader">
      <div class="content_loader_wrapper">
        <div class="content_loader_server_icon rounded-circle ms-2 "></div>
        <div class="content-loader-line-1"></div>
      </div>
    </div>
  </h1>
</ng-template>
